import React, { useState, useCallback } from "react"
import { GROUPS, PLACES, GROUPS_ELEM, GROUPS_MEDIE } from "./constants"
import { groupBy, get, uniqBy, keyBy, map } from "lodash"

/**
 * 
 * @param {{ 
 *  state: { 
 *    group: string, 
 *    space: string, 
 *    week: string, 
 *    day: string, 
 *    slice: string 
 *  }[], 
 *  setState: Function 
 * }} props 
 */
const EditRecordForm = ({ state, onCommit, onAbort, init }) => {
  const [selectedGroup, setSelectedGroup] = useState(init.group || null)
  const [selectedSpace, setSelectedSpace] = useState(init.space || null)
  const [selectedWeek, setSelectedWeek] = useState(init.week || "1a settimana")
  const [selectedDay, setSelectedDay] = useState(init.day || "Lunedì")
  const [selectedSlice, setSelectedSlice] = useState(init.slice || "pre")
  const [activity, setActivity] = useState(init.activity || "")

  const sameDateRecords = state
    .filter(item => item.week === selectedWeek && item.day === selectedDay && item.slice === selectedSlice)

  const availableGroups = GROUPS

  const spaceBusiNess = groupBy(sameDateRecords, "space")

  const availableSpaces = PLACES.filter(place => {
    const busy = get(spaceBusiNess, place.name, []).length
    if (state.find(record => record.group === selectedGroup && record.week === selectedWeek && record.day === selectedDay && record.slice === selectedSlice && record.space === selectedSpace)) {
      return true
    }
    if (busy >= place.capacity) {
      return false
    }
    if (place.incompatible.some(placeName => placeName in spaceBusiNess)) {
      return false
    }
    return true
  })

  const availableSlices = ["pre", "post"]

  const availableWeeks = ["1a settimana", "2a settimana", "3a settimana", "4a settimana"]

  const availableDays = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì"]

  const suggestActivities = uniqBy(state.map(record => record.activity))

  const handleSubmit = useCallback(e => {
    e.preventDefault()
    onCommit({
      group: selectedGroup,
      space: selectedSpace,
      week: selectedWeek,
      day: selectedDay,
      slice: selectedSlice,
      activity: activity
    })
    return false
  }, [activity, onCommit, selectedDay, selectedGroup, selectedSlice, selectedSpace, selectedWeek])

  const infeasible =
    availableGroups.length === 0 ||
    availableSlices.length === 0 ||
    availableSpaces.length === 0 ||
    availableWeeks.length === 0 ||
    availableDays.length === 0 ||
    activity.length === 0 ||
    (selectedSpace && !(selectedSpace in keyBy(availableSpaces.map(s => s.name))))

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Gruppo
        <select value={selectedGroup || "no"} onChange={e => setSelectedGroup(e.target.value)}>
          <option value="no">Seleziona gruppo</option>
          {GROUPS_ELEM.filter(g => availableGroups.includes(g)).length > 0 && (
            <optgroup label="Elementari">
              {GROUPS_ELEM.filter(g => availableGroups.includes(g)).map(g => (
                <option key={g} value={g}>{g}</option>
              ))}
            </optgroup>
          )}
          {GROUPS_MEDIE.filter(g => availableGroups.includes(g)).length > 0 && (
            <optgroup label="Medie">
              {GROUPS_MEDIE.filter(g => availableGroups.includes(g)).map(g => (
                <option key={g} value={g}>{g}</option>
              ))}
            </optgroup>
          )}
        </select>
      </label>

      <label>
        Settimana
        <select value={selectedWeek} onChange={e => setSelectedWeek(e.target.value)}>
          {availableWeeks.map(w => (
            <option key={w} value={w}>{w}</option>
          ))}
        </select>
      </label>

      <label>
        Giorno
        <select value={selectedDay} onChange={e => setSelectedDay(e.target.value)}>
          {availableDays.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </label>

      <label>
        Fascia
        <select value={selectedSlice} onChange={e => setSelectedSlice(e.target.value)}>
          {availableSlices.map(sl => (
            <option key={sl} value={sl}>{sl}</option>
          ))}
        </select>
      </label>

      <label>
        Spazio
        <select value={selectedSpace} onChange={e => setSelectedSpace(e.target.value !== "no" ? e.target.value : null)}>
          <option value="no">Seleziona spazio</option>
          {map(groupBy(availableSpaces, "location"), (places, location) => (
            <optgroup label={location} key={location}>
              {places.map(place => (
                <option key={place.name} value={place.name}>{place.name}</option>
              ))}
            </optgroup>
          ))}
        </select>
      </label>

      <label>
        Attività
        <input type="text" value={activity} onChange={e => setActivity(e.target.value)} list="suggest" />
        <datalist id="suggest">
          {suggestActivities.map(a => (
            <option key={a}>{a}</option>
          ))}
        </datalist>
      </label>

      <button type="submit" className="btn btn-sm btn-primary" disabled={selectedGroup === null || infeasible}>Inserisci</button>
    </form>
  )
}

export default EditRecordForm